<div class="fs-2 with-close" mat-dialog-title>
    Information DPE
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <img src="assets/dpe.avif" />

    <h3 class="mt-5">Rappel loi Climat et résilience</h3>
    <img src="assets/V2_Passoire_schema_audit-1-1024x529.jpg" width="640" />
</div>
<div mat-dialog-actions>
    <button type="button" (click)="onNoClick()"  class="btn btn-outline w-100">
        Fermer
    </button>
</div>
